class InfoSlide {
	constructor( $dom ){
		this.dom 		= $dom;
		this.lists 		= $dom.querySelectorAll("li");
		this.current 	= 0;
		this.max 		= this.lists.length;
		this.prev 		= $dom.parentNode.querySelector("button[data-info-prev]");
		this.next 		= $dom.parentNode.querySelector("button[data-info-next]");
		this.canClick	= true;
		this.nav();
		this.checkNav();
		this.startTime = getTime();
		this.bar = document.querySelector(".c-line span");
		//console.log(this.max);
		if( this.max > 1 ){
			this.check();
		}else{
			let $info = document.querySelector("#b-content_top .c-block_info");
			if( !$info.classList.contains("single") ){
				$info.classList.add("single");
			}
		}
		
		this.isChanging = false;
		this.checkTimer = null;
	}
	nav(){
		this.prev.removeEventListener("click", { name: this, handleEvent: this.dec}, false);
		this.prev.addEventListener("click", { name: this, handleEvent: this.dec}, false);
		
		this.next.removeEventListener("click", { name: this, handleEvent: this.inc}, false);
		this.next.addEventListener("click", { name: this, handleEvent: this.inc}, false);
	}
	inc(e){
		let $this = this.name;
		if( $this.canClick ){
			$this.canClick = false;
			setTimeout(function(){
				$this.dom.classList.add("next");
				$this.current++;
				if( $this.current >= $this.max ){
					$this.current = $this.max - 1;
					$this.canClick = true;
				}else{
					$this.change();
				}
			}, 50);
		}
	}
	dec(e){
		let $this = this.name;
		if( $this.canClick ){
			$this.canClick = false;
			$this.dom.classList.add("notransition");
			setTimeout(function(){
				$this.dom.classList.add("prev");
				$this.current--;
				if( $this.current < 0 ){
					$this.current = 0;
					$this.canClick = true;
				}else{
					$this.change();
				}
			});
		}
	}
	change(){
		let $this = this;
		if( !$this.isChanging ){
			$this.isChanging = true;
			$this.startTime = getTime();
			$this.bar.style.width = "0%";
			//console.log("change");
			$this.lists.forEach( ($li, index) => {
				if( $li.classList.contains("active") ){
					$li.classList.remove("active");
					$li.classList.add("disable");
				}else{
					if( $li.classList.contains("disable") ){
						$li.classList.remove("disable");
					}
				}
			});
			
			setTimeout(function(){
				$this.lists.forEach( ($li, index) => {
					if( $this.current === index ){
						$li.classList.add("active");
					}
				});
				$this.checkNav();
				setTimeout(function(){
					if( $this.dom.classList.contains("prev") ){
						$this.dom.classList.remove("prev");
					}
					if( $this.dom.classList.contains("next") ){
						$this.dom.classList.remove("next");
					}
					clearTimeout($this.checkTimer);
					$this.canClick = true;
					$this.isChanging = false;
					$this.check();
				}, 300);
			}, 200);
		}
	}
	checkNav(){
		let $this = this;
		let $p = this.prev;
		let $n = this.next;
		if( $this.max > 1 ){
			if( $this.current === 0 ){
				if( !$p.classList.contains("disable") ){
					$p.classList.add("disable");
				}
				if( $n.classList.contains("disable") ){
					$n.classList.remove("disable");
				}
			}else if( $this.current === $this.max - 1){
				if( $p.classList.contains("disable") ){
					$p.classList.remove("disable");
				}
				if( !$n.classList.contains("disable") ){
					$n.classList.add("disable");
				}
			}else{
				if( $p.classList.contains("disable") ){
					$p.classList.remove("disable");
				}
				if( $n.classList.contains("disable") ){
					$n.classList.remove("disable");
				}
			}
		}else{
			if( !$p.classList.contains("disable") ){
				$p.classList.add("disable");
			}
			if( !$n.classList.contains("disable") ){
				$n.classList.add("disable");
			}
			let $info = document.querySelector("#b-content_top .c-block_info");
			if( !$info.classList.contains("single") ){
				$info.classList.add("single");
			}
		}
	}
	check(){
		let $this = this;
		let current = getTime();
		let diff = current - this.startTime;
		let duration = 8000;
		let per = diff/duration;
		$this.bar.style.width = per*100 + "%";
		if( diff >= duration ){
			$this.startTime = getTime();
			$this.bar.style.width = "0%";
			if( $this.canClick ){
				$this.canClick = false;
				setTimeout(function(){
					$this.dom.classList.add("next");
					$this.current++;
					if( $this.current >= $this.max ){
						$this.current = 0;
					}
					$this.change();
				}, 50);
			}
		}else{
			// ★ 前のタイマーを潰してから新しく張る
			clearTimeout($this.checkTimer);
			$this.checkTimer = setTimeout(function(){
				$this.check();
			}, 100);
		}
	}
}

export let topInfoSlide = {
	slide: "",
	init: function(){
		if(topInfoSlide.slide){
			topInfoSlide.slide = null;
		}
		let $slide = document.querySelector("[data-info-slide]");
		if( $slide ){
			topInfoSlide.slide = new InfoSlide($slide);
		}
	}
}
let getTime = () => {
	let n = new Date();
	return n.getTime();
}